"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = {
    blue: {
        default: '#0D55B6',
        dark: '#013E90',
        medium: '#98BDED',
        light: '#E3EFFF'
    },
    pink: {
        default: '#C9365B',
        dark: '#972F48',
        medium: '#FFB4C7',
        light: '#FFF2F5'
    },
    green: {
        default: '#0d8667',
        light: '#dcf2e0',
        dark: '#0a674f'
    },
    greyscale: {
        default: '#757575',
        darker: '#232323',
        dark: '#444444',
        medium: '#C1C1C1',
        light: '#EAEAEA',
        lighter: '#f7f7f7',
        lightest: '#ffffff'
    }
};
// TODO: definitions for gradients and shadows
const colours = {
    primary: exports.palette.blue,
    error: exports.palette.pink,
    success: exports.palette.green,
    neutral: exports.palette.greyscale,
    text: exports.palette.greyscale,
    background: {
        default: exports.palette.greyscale.lighter,
        lighter: exports.palette.greyscale.lightest
    },
    delimiter: {
        default: exports.palette.greyscale.light,
        dark: exports.palette.greyscale.medium
    },
    shadow: {
        default: '#0000000f'
    }
};
const spacing = {
    default: '10px',
    small: '5px',
    large: '20px',
};
const typography = {
    fonts: {
        base: '\'Circular Std\', Arial, sans-serif',
        icons: 'TravelNest'
    },
    styles: {
        a1: {
            definition: 'This header style is used for marketing website hero headers',
            size: '4.375rem',
            height: '5rem',
            weight: 'bolder'
        },
        a2: {
            definition: 'This header style is used for marketing website headers',
            size: '3.5rem',
            height: '3.875rem',
            weight: 'bolder'
        },
        a3: {
            definition: 'This header style is used for marketing website headers',
            size: '2.5rem',
            height: '3.5rem',
            weight: 'bold'
        },
        b1: {
            definition: 'This header style is used within the customer account',
            size: '1.5rem',
            height: '1.875rem',
            weight: 'bold'
        },
        b2: {
            definition: 'This style is used as featured text at the start of paragraphs',
            size: '1.375rem',
            height: '1.5rem',
            weight: 'normal'
        },
        c1: {
            definition: 'This style is used for form titles and checklist items',
            size: '1.125rem',
            height: '1.375rem',
            weight: 'bold'
        },
        c2: {
            definition: 'This style is used for supportive form titles and secondary checklist items',
            size: '1rem',
            height: '1.275rem',
            weight: 'bold'
        },
        d1: {
            definition: 'This style is used for standard body copy across marketing website and customer account',
            size: '1.125rem',
            height: '1.375rem',
            weight: 'normal'
        },
        e1: {
            definition: 'These are small type styles used for tertiary and legal text',
            size: '0.6875rem',
            height: '0.875em',
            weight: 'normal'
        }
    }
};
const layout = {
    container: {
        maxWidth: '1200px'
    },
    radius: {
        default: '10px',
        squared: '5px'
    }
};
const motion = {
    transition: {
        default: '0.2s'
    }
};
exports.presetTheme = (component, presets) => (props) => component(Object.assign({}, presets, props));
exports.default = {
    colours,
    layout,
    motion,
    spacing,
    typography,
    presetTheme: exports.presetTheme
};
//# sourceMappingURL=index.js.map